export const siteCodes = [
    { name: 'Movilidad urbana', code: 1013 },
    { name: 'Tecnología', code: 1014 },
    { name: 'Hogar Premium', code: 1015 },
];